import { IIconProps } from "../types"

export default function IconLR6(props: IIconProps) {
  const width = props.size || props.width || (98 / 5) * 3
  const height = props.size || props.height || (84 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 98 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.15384 9.52631C6.88329 6.24736 9.23254 4.18802 12.4615 2.73848C15.6805 1.28895 19.7692 0.449219 23.7479 0.449219C27.7366 0.449219 31.6154 1.28895 35.2442 2.31862C38.883 3.34829 42.2819 4.5679 45.6709 5.21769C49.0698 5.86748 52.4687 5.93746 55.8976 5.59757C59.3265 5.25768 62.7854 4.48792 65.8344 3.79815C68.8834 3.11836 71.5126 2.50856 74.4216 2.65851C77.3307 2.80846 80.5197 3.72817 83.5687 4.94778C86.6177 6.16739 89.5268 7.6969 91.986 9.67626C94.4452 11.6656 96.4546 14.1048 97.1843 21.8124C97.9041 29.5199 97.3543 42.4957 96.2446 52.3426C95.135 62.1894 93.4755 68.8973 91.5361 72.756C89.5968 76.6148 87.3775 77.6045 83.0789 78.5142C78.7902 79.4339 72.4123 80.2736 63.4052 81.1134C54.3981 81.9531 42.7618 82.7928 34.5944 82.7928C26.417 82.7928 21.7085 81.9531 18.2097 80.7335C14.7108 79.5139 12.4215 77.9044 10.4122 74.8554C8.4028 71.8063 6.67336 67.2978 4.90392 60.6999C3.14449 54.092 1.33507 45.3948 0.715266 38.567C0.0954652 31.7392 0.645289 26.7708 1.47502 22.0423C2.30476 17.3138 3.4144 12.8053 5.15384 9.52631Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
